<div class="grid-container margin-top">
    <div class="grid-x">
        <div class="cell large-3 medium-3 small-6 padding-right-small text-align-right">
            Check Compliance as of:
        </div>
        <div class="cell large-2 medium-2 small-6 padding-left-small padding-right-small">
            <common-date-picker [id]="'calculationDate'" [daysPast]="1" [formGroup]="form?.get('calculationDate')" [disabled]="dataLoading" (dateUpdated)="calculationDateChanged($event)"></common-date-picker>
        </div>
        <div class="cell large-2 medium-2 small-6 padding-left-small">
            <button class="button" (click)="runReport()">Calculate</button><span class="padding-left-small top-align"><help-text [helpText]="forceRefreshHelp"></help-text></span>
        </div>
        <div [formGroup]="form" class="cell large-5 medium-5 small-6 padding-left-small">
            <div class="checkbox">
                <input class="show-for-sr" id="force" type="checkbox" formControlName="forceRefreshInsurance" />
                <label for="force">
                    <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span><span class="control-label-text padding-left">Reload Insurance Details</span>
                </label>
            </div>
            
        </div>
        <div class="cell large-12 medium-12 small-12">
            <ag-grid-angular class="data-grid  full-page" [gridOptions]="gridOptions" [rowData]="data" [excelStyles]="excelStyles"  aria-label="Insurance Compliance By Date Report"></ag-grid-angular>
        </div>
    </div>
</div>